import { rashifalReadingHref } from "@/lib/rashifal-reading-href";

/**
 * The /tomorrow-horoscope/ "which rashi is yours?" check's own props.
 * Everything the reader sees of the form (its words, its frame, its field ids
 * and its no-time explainer) is the /rashi/<sign>/ check's
 * (components/rashi/rashi-check-form.ts), imported unchanged; only the
 * analytics placement, the slot's room and the answer's next step belong to
 * this page.
 */

/** free_tool_started and calculator_used placement for this page's check. */
export const TOMORROW_RASHI_CHECK_PLACEMENT = "tomorrow_horoscope_page_check";

/**
 * The slot's floor, from the server HTML: the tallest measured state, which
 * every state fills (TomorrowRashiCheckLazy has the numbers).
 */
export const TOMORROW_RASHI_CHECK_RESERVE = "min-h-[600px] sm:min-h-[500px]";

/**
 * The id of a sign's tomorrow reading on this page: the article
 * DailyEngineRashiSection renders for each of the 12 rashis.
 */
export function tomorrowReadingId(rashi: string): string {
  return `rashi-${rashi}`;
}

/**
 * A sign's daily reading, the link the check gives when the engine could not
 * compute tomorrow for this render (no per-sign reading is on the page then):
 * its card on the /rashifal/ hub, since the 12 /rashifal/<sign>/ pages merged
 * there on 2026-10-25.
 */
export function rashifalSignHref(rashi: string): string {
  return rashifalReadingHref(rashi);
}
